import DadosExameService from './dadosExameService';

class DadosExameManager {
  async buscarListaCodigosExame() {
    return await DadosExameService.buscarListaCodigosExame()
      .then(resposta => {
        return {
          lista: resposta.data.filter(item => item.codigoRelacionamentoExame)
        };
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            return {
              lista: []
            };
          }
          return {
            mensagem: error.response.data
          };
        }
      });
  }

  async listaExames(termo, ehVeterinario, material) {
    try {
      return await DadosExameService.listaExames(termo, ehVeterinario, material)
        .then(resposta => {
          return {
            lista: resposta.data
          };
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 404) {
              return {
                lista: []
              };
            }
            return {
              mensagem: error.response.data
            };
          }
        });
    } catch (error) {
      console.log('error :', error);
    }
  }

  async listaExamesContratoLicitacao(codigoContrato) {
    try {
      return await DadosExameService.listarExamesContratoLicitacao(codigoContrato)
        .then(resposta => {
          return {
            lista: this._prepararRetornoComPalavrasChave(resposta.data)
          };
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 404) {
              return {
                lista: []
              };
            }
            return {
              mensagem: error.response.data
            };
          }
        });
    } catch (error) {
      console.log('error :', error);
    }
  }

  async obterExame(mnemonico, material) {
    try {
      return await DadosExameService.obterExame(mnemonico, material)
        .then(resposta => {
          return {
            exame: resposta.data
          };
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 404) {
              return {
                exame: null
              };
            }
            return {
              mensagem: error.response.data
            };
          }
        });
    } catch (error) {
      console.log('error :', error);
    }
  }

  async listarMateriais(mnemonico, material) {
    return await DadosExameService.listarMateriais(mnemonico, material)
      .then(resposta => {
        return {
          materiais: resposta.data
        };
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            return {
              materiais: []
            };
          }
          return {
            mensagem: error.response.data
          };
        }
      });
  }

  async listarConservantes(mnemonico, mnemonicoMaterial, codigoMaterial) {
    return await DadosExameService.listarConservantes(mnemonico, mnemonicoMaterial, codigoMaterial)
      .then(resposta => {
        return {
          conservantes: resposta.data
        };
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            return {
              conservantes: []
            };
          }
          return {
            mensagem: error.response.data
          };
        }
      });
  }

  _prepararRetornoComPalavrasChave(exames) {
    exames.forEach(exame => {
      if (exame.palavrasChaves && exame.palavrasChaves.length > 0)
        exame.palavrasChaves = exame.palavrasChaves.join("");
    });

    return exames;
  }
}

export default new DadosExameManager();
